import React from 'react';
import SpSessionCard from '../Utilities/SpSessionCard';

const API_URL =
  'https://adroid-admin.vercel.app/api/v1/sessions?conference_id=c4';

const SpSessions = () => {
  const [sessions, setSessions] = React.useState([]);
  const [loading, setLoading] = React.useState(true);
  const [error, setError] = React.useState('');

  React.useEffect(() => {
    const controller = new AbortController();

    const fetchSessions = async () => {
      try {
        const response = await fetch(API_URL, {
          signal: controller.signal,
        });

        if (!response.ok) {
          throw new Error('Failed to fetch special sessions.');
        }

        const data = await response.json();
        setSessions(data.items || []);
      } catch (err) {
        if (err.name !== 'AbortError') {
          console.error('Error fetching sessions:', err);
          setError('Unable to load special sessions. Please try again later.');
        }
      } finally {
        if (!controller.signal.aborted) {
          setLoading(false);
        }
      }
    };

    fetchSessions();

    return () => controller.abort();
  }, []);

  return (
    <div>
      <h1 className="text-4xl font-semibold text-center m-3">
        Special Sessions
      </h1>

      <hr className="mb-4 border-black border-2 w-96 m-auto" />

      {loading && (
        <p className="text-center p-4">Loading special sessions...</p>
      )}

      {error && <p className="text-center p-4">{error}</p>}

      {!loading && !error && sessions.length === 0 && (
        <p className="text-center p-4">No special sessions available.</p>
      )}

      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-3 gap-4 p-4">
        {sessions.map((session, ind) => {
          const authors = (session.organisers || [])
            .map((organiser) =>
              organiser.designation
                ? `${organiser.name}, ${organiser.designation}`
                : organiser.name
            );

          return (
            <SpSessionCard
              key={`${session.conference_id}-${session.session_id}`}
              name={session.title}
              authors={authors}
              file={session.pdf_url}
              ind={ind + 1}
            />
          );
        })}
      </div>
    </div>
  );
};

export default SpSessions;